import { readFile } from "fs/promises";
import "path";
import { o as objectValuesWithId } from "../../../../../chunks/objectValuesWithId.js";
const prerender = true;
const teamsPath = "src/teams.json";
const playersPath = "src/_players.json";
const players = JSON.parse(await readFile(playersPath, "utf8"));
const teams = JSON.parse(await readFile(teamsPath, "utf8"));
async function load({ fetch, params }) {
  const team = teams[
    // (await read("/" + path.resolve("./") + "/" + teamsPath).json())
    params.id
  ] ?? // (await read(teamsPath).json())[params.id] ??
  await (await fetch(
    `https://ugpl-ce55b-default-rtdb.europe-west1.firebasedatabase.app/teams/${params.id}.json`
    // "https://ugpl-ce55b-default-rtdb.europe-west1.firebasedatabase.app/players.json" +
    //   "?orderBy=%22teamid%22&equalTo=%22" +
    //   params.id +
    //   "%22"
  )).json();
  const data = (
    // Object.values(
    objectValuesWithId(
      // (await read("/" + path.resolve("./") + "/" + playersPath).json())
      players
    ).filter(
      // Object.values(await read(playersPath).json()).filter(
      (v, i, l) => v.teamid == params.id
    ) || // Object.values(
    objectValuesWithId(
      await (await fetch(
        // "https://ugpl-ce55b-default-rtdb.europe-west1.firebasedatabase.app/players.json"
        "https://ugpl-ce55b-default-rtdb.europe-west1.firebasedatabase.app/players.json?orderBy=%22teamid%22&equalTo=%22" + params.id + "%22"
      )).json()
    )
  );
  return { team, players: data };
}
export {
  load,
  prerender
};
